import { InputAmount } from '@vrplatform/components';
import { Input as MantineInput } from '@mantine/core';
import { Controller, useFormContext } from 'react-hook-form';
import type { FormInputBaseType } from './_base-input-types';

type CurrencyInputType = {
  currency?: string;
};

type Props = CurrencyInputType & FormInputBaseType;

export const CurrencyInput = ({
  label,
  formKey,
  defaultValue = '',
  required = true,
  disabled,
  placeholder,
  // currency,
  onValueChange,
}: Props) => {
  const { control } = useFormContext();

  // TODO: Fix possible currencies
  return (
    <MantineInput.Wrapper label={label}>
      <Controller
        control={control}
        name={formKey}
        defaultValue={defaultValue}
        rules={{ required: required }}
        render={({ field: { onChange, value } }) => (
          <InputAmount
            placeholder={placeholder || label || ''}
            value={value}
            setValue={(value) => {
              onValueChange?.(formKey, value.toString());
              onChange(value);
            }}
            name={formKey}
            disabled={disabled}
            sx={{ input: { borderColor: '#CED0D780' } }}
            decimalScale={2}
          />
        )}
      />
    </MantineInput.Wrapper>
  );
};
